import React from 'react';
import { Modal } from './Modal';
import { Button } from './Button';

export interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Se ejecuta al pulsar el botón rojo (Eliminar) */
  onConfirm: () => void;
  title?: string;
  /** Texto principal (puede incluir <strong> para el nombre del ítem) */
  message: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  isLoading?: boolean;
}

/**
 * Modal estándar para confirmar eliminaciones y evitar borrados accidentales.
 */
export const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirmar eliminación',
  message,
  confirmLabel = 'Eliminar',
  cancelLabel = 'Cancelar',
  isLoading = false,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={() => {
      if (!isLoading) onClose();
    }}
    title={title}
    size="sm"
    footer={
      <>
        <Button variant="secondary" type="button" onClick={onClose} disabled={isLoading}>
          {cancelLabel}
        </Button>
        <Button variant="danger" type="button" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? 'Eliminando…' : confirmLabel}
        </Button>
      </>
    }
  >
    <div className="py-1">
      <div className="text-gray-700 mb-3">{message}</div>
      <p className="text-sm text-gray-500">Esta acción no se puede deshacer.</p>
    </div>
  </Modal>
);
